<template lang="pug">
  div(class="upload-images")
    v-slide-group(show-arrows)
      v-slide-item(v-for="(image, index) in images" :key="index" v-slot:default="{ active, toggle }")
        .images-preview
          .img
            v-img(:src="image.src" width="160" height="120")
            div(@click="removeFile(index)" ).file-remove
              v-icon(color="red" small) close
    .drop-zone
      input(
        name="uploadImages"
        type="file"
        @change="selectFiles"
        multiple)
</template>

<docs>
  ```html
  <UploadImages @set-files="" imageList="" isEdit="" />
  ```
</docs>

<script>
import debounce from '../../tools/debounce'

const oneAlert = debounce(() => {
  alert('Максимальное количество фотографий равно 10')
}, 1000)

export default {
  name: 'UploadImages',
  props: {
    /**
     * Массив ссылок на фотографии
     */
    imageList: {
      type: Array,
      default: () => [],
      required: false
    },
    /**
     * Параметр сигнализирующий о возможности редактирования
     */
    isEdit: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    images: []
  }),
  watch: {
    images(values) {
      this.$emit('set-files', values)
    },
    imageList(values) {
      this.images = values.map(item => {
        return { src: item, file: null }
      })
    }
  },
  methods: {
    /**
     * Метод позволяет удалить File из массива Files по индексу.
     *
     * @param {string} index - индекс файла в массиве Files
     * @public
     */
    removeFile(index) {
      this.images.splice(index, 1)
    },
    selectFiles($event) {
      const files = $event.target.files
      Object.keys(files).map(file => {
        const reader = new FileReader()
        reader.onloadend = () => {
          let images = Object.keys(this.images).map(item => this.images[item])
          if (images.length >= 10) {
            oneAlert()
            return
          }
          this.images = [...images, { src: reader.result, file: files[file] }]
        }
        reader.readAsDataURL(files[file])
      })
    }
  }
}
</script>

<style lang="scss">
.upload-images {
  margin: 24px 0;
}
.images-preview {
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0;
  .img {
    position: relative;
    display: flex;
    margin: 6px 16px 12px 0;
    .v-image {
      position: relative;
      border-radius: 6px;
    }
    .file-remove {
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      top: 5px;
      right: 5px;
      z-index: 10;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
.drop-zone {
  position: relative;
  max-width: 100%;
  width: 100%;
  height: 100px;
  border: dashed 1px #8e8e93;
  border-radius: 6px;
  &:before {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #8e8e93;
    font-weight: 600;
    line-height: 1;
    content: 'Выберите фотографии или перетащите в область';
  }
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
